<template>
<div>
    <table-page
        :client="client"
        @updated="getTaxes"
        :warnings="warnings"
        :changelogs="changelogs"
        :hideTabs="true"
    >
        <fast-table
            :recordLabel="recordLabel"
            :sections="sections"
            :headers="headers"
            :data="tableData"
            :activeRowId="currentRowId"
            @click="currentRowId = $event.id"
        >
            <template v-slot:table-actions>
                <button class="btn btn-primary btn-collapse" id="addButton" @click="openAddModal">
                    <i class="far fa-fw fa-plus"></i> <span class="btn-text">Add Tax Registration</span>
                </button>
            </template>
        </fast-table>

        <add-form-modal
            v-if="addModalOpen"
            :client="client"
            :tax-registrations="taxRegistrations"
            ref="addModal"
            @updated="getTaxes"
            @close="addModalOpen = false"
        />
    </table-page>

    <sidebar
        v-if="currentRowId"
        :client="client"
        :tax-registration-id="currentRowId"
        @updated="getTaxes"
        @close="currentRowId = null"
    >
    </sidebar>
</div>
</template>

<script>
import TablePageMixin from '@/mixins/TablePageMixin'
import FastTable from '@/components/FastTable'
import Sidebar from './components/CompanyTaxes/Sidebar'
import AddFormModal from './components/CompanyTaxes/AddFormModal'

export default {
    components: {FastTable, Sidebar, AddFormModal},
    mixins: [TablePageMixin],
    props: ['client'],
    computed: {
        currentRow() {
            return this.taxRegistrations.find(x => (x.id == this.currentRowId))
        },
        sections() {
            return [
                {title: 'Active', defaultIsClosed: false, id: 'active', hasDateFilter: false},
                {title: 'Inactive', defaultIsClosed: false, id: 'inactive', hasDateFilter: false},
            ]
        },
        tableData() {
            const tableData = [[], []]
            if (!this.taxRegistrations.length) {
                return tableData
            }

            const sections = [
                this.taxRegistrations.filter(tr => tr.is_active),
                this.taxRegistrations.filter(tr => !tr.is_active),
            ]

            sections.forEach((section, idx) => {
                section.forEach(tr => {
                    const company = this.client.companies.find(c => c.id == tr.company_id)
                    tableData[idx].push({
                        id: tr.id,
                        object: tr,
                        cells: [
                            tr.tax.name,
                            company.name,
                            tr.tax.type_pretty,
                            tr.tax.jurisdiction.type_pretty,
                            tr.tax.jurisdiction.canonical_name,
                            tr.is_voluntary ? 'Yes' : 'No',
                            tr.filing_id,
                        ],
                    })
                })
            })

            return tableData
        },
    },
    data() {
        return {
            taxRegistrations: [],
            dataLoaded: false,
            currentRowId: null,
            recordLabel: "Tax Registrations",
            headers: [
                {label: 'Tax Name', classes: '', isSearchable: true, defaultSort: true},
                {label: 'Company', classes: '', isSearchable: false, isFilterable: true},
                {label: 'Type', classes: '', isSearchable: false, isFilterable: true},
                {label: 'Jurisdiction Type', classes: '', isSearchable: false, isFilterable: true},
                {label: 'Jurisdiction', classes: '', isSearchable: false, isFilterable: true},
                {label: 'Voluntary?', classes: '', isSearchable: false, isFilterable: true},
                {label: 'Filing ID', classes: '', isSearchable: true},
            ],
            addModalOpen: false
        }
    },
    mounted() {
        this.$store.dispatch('SET_PAGE_TITLE', 'Settings / Taxes')
        this.getTaxes()
    },
    methods: {
        getTaxes() {
            this.$store.dispatch('START_LOADING')
            this.$api.get(`/clients/${this.client.id}/settings/tax-registrations`).then(resp => {
                this.taxRegistrations = resp
                this.$store.dispatch('STOP_LOADING')
            }).catch((errors) => {
                this.$store.dispatch('STOP_LOADING')
                if (errors.__status__ == 403) {
                    this.$bus.$emit('no-access')
                }
                else {
                    this.$bus.showError(errors.__all__)
                }
            })
        },
        openAddModal() {
            this.addModalOpen = true
        },
    },
}
</script>
